import { MenuItem, SelectChangeEvent } from '@mui/material';
import { OutlinedSelect } from '@/components/common/field/OutlinedSelect';
import { SUDOKU_TYPE_LABELS, SudokuType } from '@/types/create/SudokuType';
import React, { FC } from 'react';

interface Props {
  value: SudokuType;
  options: SudokuType[];
  onValueChange: (value: SudokuType) => void;
  disabled?: boolean;
}

export const SudokuTypeSelectorField: FC<Props> = (props: Props) => {
  const { value, options, onValueChange, disabled } = props;

  return (
    <OutlinedSelect
      name={'sudokuType'}
      size={'small'}
      label={'Тип судоку'}
      value={value}
      disabled={disabled}
      onChange={(e: SelectChangeEvent<unknown>): void => {
        onValueChange(e.target.value as SudokuType);
      }}>
      {options.map((type: SudokuType) => (
        <MenuItem key={type} value={type}>
          {SUDOKU_TYPE_LABELS[type]}
        </MenuItem>
      ))}
    </OutlinedSelect>
  );
};
